var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"attached-menu-container"},[_c('v-menu',_vm._b({ref:_vm.componentId,attrs:{"attach":("#" + _vm.componentId)},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({attrs:{"id":_vm.componentId}},'span',attrs,false),on),[_vm._t("activator")],2)]}},{key:"default",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)},'v-menu',_vm.menuProps,false))],1)])}
var staticRenderFns = []

export { render, staticRenderFns }